import constants from '../constants';
import authAxios from '../authorization/axios';

export const getMissingNfts = async (email: string) => {
  const main = constants.api.getMissingNfts.replace('{contactMail}', email);

  // TODO: typing the response.
  const response = await authAxios.get(main);

  return response;
};